import 'jquery-mask-plugin';

export default () => {
  $('.form__input-phone').mask('+0(000)000-00-00');
}



// WEBPACK FOOTER //
// ./resources/assets/js/new-landing-constructor/form/index.js